<template>
  <div>
    <div v-if="mode==='pc'">
      <PCMe></PCMe>
    </div>
    <div v-if="mode==='mobile'">
      <MobileMe></MobileMe>
    </div>
  </div>
</template>

<script>
import PCMe from "@/components/pc/PCNews";
import MobileMe from "@/components/mobile/mobileNews";
export default {
  data() {
    return {
      wxAppData: "",
    };
  },
  components: {
    PCMe,
    MobileMe
  },
  computed: {
    mode() {
      return this.$store.state.mode;
    }
  },
  mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/news.vue